import { uniqueId, isEqual } from 'lodash';
import createChainedFunction from 'utils/createChainedFunction';
import doWhileMounted from 'utils/doWhileMounted';
import Field from 'components/Field.jsx';
import Formsy from 'lib/Formsy';
import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import React from 'react';

const FormInput = React.createClass({
  propTypes: {
    /* when true it hides the error message until a blur event is emitted, default FALSE */
    showErrorAfterBlur: React.PropTypes.bool,
    /* show error even when no change as been made to the input, default is FALSE */
    showErrorOnPristine: React.PropTypes.bool,
    /* Execute the callback when a cursor leaves the input field */
    onBlur: React.PropTypes.func,
    /* the input type */
    type: React.PropTypes.string,
    /* use a custom component instead of Input */
    component: React.PropTypes.any,
    /* label text */
    label: React.PropTypes.node,
    /* hide label */
    labelHidden: React.PropTypes.bool,
    /* custom error message that overrides builtin validation */
    errorMessage: React.PropTypes.string,
    loading: React.PropTypes.bool,
    warning: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.element,
    ]),
  },

  mixins: [Formsy.Mixin],

  getDefaultProps() {
    return {
      showErrorAfterBlur: false,
      showErrorOnPristine: false,
    };
  },

  getInitialState() {
    // Unless type is 'password', trim input value before validation
    return {
      wasBlur: false,
      value: this.props.value,
      formatters: this.props.type === 'password' ? [] : [(value) => {
        return value && value.trim ? value.trim() : value;
      }],
    };
  },

  componentWillMount() {
    this.id = uniqueId('id-');
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.value && this.props.value !== nextProps.value) {
      this.changeValue(nextProps.value);
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props, nextProps) && isEqual(this.state, nextState));
  },

  handleBlur() {
    if (this.state.wasBlur === false) {
      this.setState({ wasBlur: true });
    }
  },

  handleChange(event) {
    // Some of our custom components that will be passed in through component
    // call onChange on the value, rather than the event.
    if (event.currentTarget) {
      this.changeValue(event.currentTarget.value);
    } else {
      this.changeValue(event);
    }

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  },

  changeValue(value) {
    let formattedValue = value;
    this.state.formatters.forEach(formatter => {
      formattedValue = formatter(formattedValue);
    });

    this.setValue(formattedValue);
    this.setState({
      // the state always hold the real value.
      value,
      wasBlur: false,
    });
  },

  /* This is for autofill purposes.
   * Some browsers does not emit change event when
   * they fill out the forms, so formzy is not aware
   * the value change and the validation does not run.
   * This pulls the value from the DOM at
   * regular interval and if what is found is different
   * than what formzy currently have then we tell formzy
   * about this new value via the formzy mixin.
   */
  lookForChanges() {
    if (!this.refs.input) {
      return;
    }

    const { value } = this.refs.input.getInputNode();
    if (value && this.getValue() !== value) {
      const event = {
        currentTarget: { value },
        target: { value },
      };
      this.handleChange(event);
    }
  },

  focus() {
    if (this.refs.input.focus) {
      this.refs.input.focus();
    }
  },

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return (
        <Label htmlFor={this.id} hidden={this.props.labelHidden}>
          {label}
        </Label>
      );
    } else {
      return null;
    }
  },

  render() {
    let errorMessage = this.getErrorMessage();

    if (this.props.showErrorAfterBlur && !this.state.wasBlur) {
      errorMessage = null;
    }

    if (!this.props.showErrorOnPristine && this.isPristine()) {
      errorMessage = null;
    }

    errorMessage = this.props.errorMessage || errorMessage;

    const Component = this.props.component || Input;

    return (
      <Field error={errorMessage} warning={this.props.warning} loading={this.props.loading}>
        {this.renderLabel()}
        <Component
          {...this.props}
          ref="input"
          id={this.id}
          value={this.state.value || ''}
          onBlur={createChainedFunction(this.props.onBlur, this.handleBlur)}
          onChange={this.handleChange}
        />
      </Field>
    );
  },
});

export default doWhileMounted(FormInput, 'lookForChanges', 1000);



// WEBPACK FOOTER //
// ./src/components/FormInput.jsx